var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionQuote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6606 12.5356C14.6606 9.19792 11.9186 6.49219 8.53554 6.49219C5.15244 6.49219 2.69694 9.10468 2.41044 12.4305C1.97304 17.5055 5.88054 21.7545 10.6244 23.1064C9.00744 22.1417 7.87944 20.464 7.69134 18.5127C7.96824 18.5515 8.24844 18.5791 8.53554 18.5791C11.9186 18.5791 14.6606 15.8736 14.6606 12.5356Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5997 12.5356C27.5997 9.19792 24.8577 6.49219 21.4743 6.49219C18.0915 6.49219 15.6357 9.10468 15.3489 12.4305C14.9115 17.5055 18.819 21.7545 23.5632 23.1064C21.9462 22.1417 20.8185 20.464 20.6301 18.5127C20.907 18.5515 21.1875 18.5791 21.4743 18.5791C24.8577 18.5791 27.5997 15.8736 27.5997 12.5356Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionQuote);
export default __webpack_public_path__ + "static/media/question_quote.bb175337a8463ba17a1d1489c7c9b5d1.svg";
export { ForwardRef as ReactComponent };